import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_RATA } from '../../data.const';
import {
  setCurrentRataAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const retrieveRataEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_RATA),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_RATA}]`, p)),
    withLatestFrom(state$),
    switchMap(([id, _state]) => {
      return concat(
        of(setLoaders({ onorarioLoader: true })),
        defer(() =>
          from(request({ path: `rata/${id}`, method: httpMethods.GET })).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p?.result;
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_RATA}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(p => of(setCurrentRataAction(p))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_RATA}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ onorarioLoader: false }))
      );
    })
  );

export default retrieveRataEpic;
